/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeletionTrackingEntryDTO,
} from '../models/index';
import {
    DeletionTrackingEntryDTOFromJSON,
    DeletionTrackingEntryDTOToJSON,
} from '../models/index';

export interface GetDeletedOrganisationsRequest {
    from?: Date;
    until?: Date;
}

export interface GetDeletedPersonsRequest {
    from?: Date;
    until?: Date;
}

export interface GetDeletedProjectsRequest {
    from?: Date;
    until?: Date;
}

export interface GetDeletedPublishersRequest {
    from?: Date;
    until?: Date;
}

export interface GetDeletedWorksRequest {
    from?: Date;
    until?: Date;
}

/**
 * 
 */
export class DeletionTrackingApi extends runtime.BaseAPI {

    /**
     * Creates request options for getDeletedOrganisations without sending the request
     */
    async getDeletedOrganisationsRequestOpts(requestParameters: GetDeletedOrganisationsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/deletion-tracking/organisation`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get information about all deleted organisations. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedOrganisationsRaw(requestParameters: GetDeletedOrganisationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletionTrackingEntryDTO>> {
        const requestOptions = await this.getDeletedOrganisationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletionTrackingEntryDTOFromJSON(jsonValue));
    }

    /**
     * Get information about all deleted organisations. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedOrganisations(requestParameters: GetDeletedOrganisationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletionTrackingEntryDTO> {
        const response = await this.getDeletedOrganisationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeletedPersons without sending the request
     */
    async getDeletedPersonsRequestOpts(requestParameters: GetDeletedPersonsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/deletion-tracking/person`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get information about all deleted persons. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedPersonsRaw(requestParameters: GetDeletedPersonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletionTrackingEntryDTO>> {
        const requestOptions = await this.getDeletedPersonsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletionTrackingEntryDTOFromJSON(jsonValue));
    }

    /**
     * Get information about all deleted persons. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedPersons(requestParameters: GetDeletedPersonsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletionTrackingEntryDTO> {
        const response = await this.getDeletedPersonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeletedProjects without sending the request
     */
    async getDeletedProjectsRequestOpts(requestParameters: GetDeletedProjectsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/deletion-tracking/project`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get information about all deleted projects. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedProjectsRaw(requestParameters: GetDeletedProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletionTrackingEntryDTO>> {
        const requestOptions = await this.getDeletedProjectsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletionTrackingEntryDTOFromJSON(jsonValue));
    }

    /**
     * Get information about all deleted projects. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedProjects(requestParameters: GetDeletedProjectsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletionTrackingEntryDTO> {
        const response = await this.getDeletedProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeletedPublishers without sending the request
     */
    async getDeletedPublishersRequestOpts(requestParameters: GetDeletedPublishersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/deletion-tracking/publisher`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get information about all deleted publishers. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedPublishersRaw(requestParameters: GetDeletedPublishersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletionTrackingEntryDTO>> {
        const requestOptions = await this.getDeletedPublishersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletionTrackingEntryDTOFromJSON(jsonValue));
    }

    /**
     * Get information about all deleted publishers. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedPublishers(requestParameters: GetDeletedPublishersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletionTrackingEntryDTO> {
        const response = await this.getDeletedPublishersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeletedWorks without sending the request
     */
    async getDeletedWorksRequestOpts(requestParameters: GetDeletedWorksRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/deletion-tracking/work`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get information about all deleted works. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedWorksRaw(requestParameters: GetDeletedWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletionTrackingEntryDTO>> {
        const requestOptions = await this.getDeletedWorksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletionTrackingEntryDTOFromJSON(jsonValue));
    }

    /**
     * Get information about all deleted works. The result can be restricted by the optional parameters from and/or until
     */
    async getDeletedWorks(requestParameters: GetDeletedWorksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletionTrackingEntryDTO> {
        const response = await this.getDeletedWorksRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
